export default {
    contact: {
        firstname: "",
        lastname: "",
        salutation: "",
        title: "",
        street: "",
        city: "Jaipur",
        state: "",
        country: "",
        pincode: "",
        phone: "",
        email: "",
        referredby: null,   // UUID, can be null
        accountid: null,    // UUID, can be null
        date_of_birth: null,  // keep empty string, bind to <input type="date" />
        reference: "",
        whatsapp_no: "",
        location_link: "",
    },
    lead: {
        lead_name: "",
        leadtype: "",
        lead_status: "",
        email: "",
        phone: "",
        whatsapp_no: "",
        teliphone: "",
        anniversary_date: null,
        leadsource: "",
        owner_name: "",
        product_name: "",
        contact_name: "",
        remark: "",
        customer_type: "",
        company_name: "",
        sector: "",
        is_gst: "",
        gst_no: "",
        competitor_name: "",
        customer_primary_name: "",
        customer_primary_phone: "",
        customer_secondry_name: "",
        customer_secondary_phone: "",
        customer_secondary_designation: "",
        location_link: "",
        address: "",
        state: "",
        city: "",
        office_address: "",
        office_city: "",
        pincode: "",
        country: "",
        qty: 0,
        account_id: null,
        lead_source_status: null,
        contact_id: null,
        owner_id: null,
        product_id: null,
        createddate: null,
        date_of_birth: null
    }


}